import Avatar from "components/Home/ui/Avatar";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectMyGuid } from "slices/authSlice";
import { selectPresenceState } from "slices/efficeCacheSlice";
import {
  selectCurrentActiveEffice,
  selectCurrentPermissionsEffice,
  selectInThisSpace,
} from "slices/sharedSelectors";
import EnterButtonContainer from "./EnterButtonContainer/EnterButtonContainer";
import { selectEnterButtonLoading } from "slices/channels/spaceChannelSlice";
import RoomLink from "components/Home/VideoBarContainer/VideoBar/MyControlBar/SpaceBoxActiveControls/RoomLink/RoomLink";
import { getPersonName } from "helpers/randomHelpers";
import { iAmAdmin } from "helpers/efficeHelpers";

const SpacePage = () => {
  const currentActiveEffice = useSelector(selectCurrentActiveEffice);
  const currentPermEffice = useSelector(selectCurrentPermissionsEffice);
  const myGuid = useSelector(selectMyGuid);
  const inThisSpace = useSelector(selectInThisSpace);
  const peopleInSpace = useSelector((state) => {
    let { id, permissions_id } = currentActiveEffice;
    let pState = selectPresenceState(state)[permissions_id];
    if (pState && pState[id] && pState[id].length > 0) return pState[id];
    return null;
  });
  const [visibleList, setVisibleList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [observedInSpace, setObservedInSpace] = useState(false);
  const enterButtonLoading = useSelector(selectEnterButtonLoading);
  const onAnotherDevice =
    !enterButtonLoading && observedInSpace && !inThisSpace;

  useEffect(() => {
    let visibleList = [];
    let iAmFound = false;
    for (let luid in peopleInSpace) {
      let name =
        peopleInSpace[luid].given_name + " " + peopleInSpace[luid].family_name;

      // for (let i = 0; i < 50; i++) FOR TESTING
      if (name.toLowerCase().includes(searchTerm.toLowerCase()))
        visibleList.push(peopleInSpace[luid]);

      // Checkig manually becuase presence can update before the redux observedInSpace variable updates
      if (myGuid === peopleInSpace[luid].user_id) iAmFound = true;
    }
    if (iAmFound && !observedInSpace) setObservedInSpace(true);
    else if (!iAmFound && observedInSpace) setObservedInSpace(false);
    setVisibleList(visibleList);
  }, [searchTerm, setVisibleList, peopleInSpace, myGuid, observedInSpace]);

  return (
    <div className="space-page">
      <div className={`shifting-container`}>
        <div className={`box-background-container`}>
          <EnterButtonContainer
            currentActiveEffice={currentActiveEffice}
            enterButtonLoading={enterButtonLoading}
          />
          {onAnotherDevice && (
            <div className="present-here">
              you are already inside this space on another tab or device.
            </div>
          )}
          {!enterButtonLoading && (
            <div className={`space-peek-container`}>
              {peopleInSpace ? (
                <>
                  <div className="space-peek-header">
                    <span className="space-peek-title">People Present</span>
                    <input
                      type="text"
                      className="input-box inputSearch"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search by name"
                    />
                  </div>
                  <br />
                  <div className="space-peek-list">
                    {visibleList[0]
                      ? visibleList.map((person) => (
                          <div className="people-item" key={person.user_id}>
                            <div
                              className={`Txt-avatar d-inline-block Txt-space-people-highlight`}
                            >
                              <Avatar
                                avatar_key={person.avatar_key}
                                given_name={person.given_name}
                                family_name={person.family_name}
                              />
                            </div>
                            <div className={`Txt-member-name-role`}>
                              <div className="name-role-container">
                                <div className="Txt-member-name">
                                  {getPersonName(
                                    person.given_name,
                                    person.family_name
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : " No Results "}
                  </div>
                </>
              ) : (
                "there is no one here"
              )}
            </div>
          )}

          <div className="SPACEBOX">
            <div className="doorway no-select">
              <div className="doormat"></div>
            </div>
          </div>
        </div>
      </div>
      <div className={`my-control-bar space-box-active`}>
        <div className="space-box-active-left">
          {currentPermEffice && iAmAdmin(currentPermEffice) && <RoomLink />}
        </div>
        <div className="space-box-active-mid"></div>
        <div className=""></div>
      </div>
    </div>
  );
};

export default SpacePage;
